import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, X } from "lucide-react";
import Religion from "pages/business-suite/dummyStaff";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
interface DialogProps {
  onUploadSuccess: ({ status }: { status: string }) => void;

  isDailogRecalculate: boolean;
  setIsDailogRecalculate: (value: boolean) => void;
  selectedProductIds: any;
}
export default function DailogRecalculate({ isDailogRecalculate, setIsDailogRecalculate, selectedProductIds, onUploadSuccess }: DialogProps) {
  const { showDialogMessage } = appStore();
  const { reasonsToRecalculate } = Religion();

  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [loadingSubmitMatchingClockTime, setLoadingSubmitMatchingClockTime] = useState<any>(null);

  const submitMatchingClockTime = async () => {
    setLoadingSubmitMatchingClockTime(true);
    try {
      const url = `${RouteApi.submitMatchingClockTime}token=${token}`;
      const data = {
        shop_id: shopId,
        ids: selectedProductIds,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        onUploadSuccess({
          status: response.status,
        });
        setIsDailogRecalculate(false);
        setLoadingSubmitMatchingClockTime(false);
        showDialogMessage({
          title: response.status,
          message: response.msg,
          barrierDismissible: true,
          status: response.status,
        });
      } else {
        showDialogMessage({
          title: response.status,
          message: response.msg,
          barrierDismissible: false,
        });
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      AppLog.show({
        message: `[submitMatchingClockTime]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return (
    <>
      <Dialog open={isDailogRecalculate}>
        <DialogContent isShowBtnXClose={false} className=" max-w-[860px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <DialogHeader>
            <DialogTitle>Recalculate</DialogTitle>
            <DialogDescription>Recalculate employee timesheets.</DialogDescription>
            <div
              className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
              onClick={() => setIsDailogRecalculate(false)}
            >
              <X />
            </div>
          </DialogHeader>

          <ScrollArea className="mt-2 gap-3 overflow-hidden ">
            <div className=" mx-auto p-6 text-gray-800 dark:text-white">
              <h2 className="text-2xl font-semibold mb-4">Recalculating an Employee Timesheet</h2>
              <p className="mb-4">
                In certain situations, you may need to <strong>recalculate an employee’s timesheet</strong> to ensure that all recorded hours, breaks, and adjustments are accurate
                and reflect the most up-to-date information. This process can help maintain compliance with labor regulations, ensure fair pay, and prevent discrepancies in
                payroll.
              </p>

              <h3 className="text-xl font-semibold mb-2">When Should You Recalculate a Timesheet?</h3>
              <p className="mb-4">You should consider recalculating an employee’s timesheet in the following cases:</p>
              <ul className="list-disc pl-5 space-y-2">
                {reasonsToRecalculate.map((reason: any, index: any) => (
                  <li key={index}>
                    <strong>{reason.title}:</strong> {reason.description}
                  </li>
                ))}
              </ul>
            </div>
          </ScrollArea>
          <ScrollBar orientation="vertical" />
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
            <button
              onClick={() => {
                submitMatchingClockTime();
              }}
              className=" outline-none focus:border-none w-full mt-6 flex items-center justify-center  bg-blue-500 text-white text-lg py-2 rounded-lg"
            >
              {loadingSubmitMatchingClockTime ? <Loader className="animate-spin" /> : "Submit"}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
